// extracted by mini-css-extract-plugin
module.exports = {"spotlight-card__link--hover-no-underline":"spotlight-card__link--hover-no-underline--vnqwk"};